/**
 * @fileoverview PlannedMeetingCard — Upcoming Schedule "PLANNED" card.
 *
 * Renders an admin-scheduled meeting (upcoming_meetings status: 'scheduled')
 * that has NOT yet been converted into a real Showdown. Deliberately a
 * lighter-weight sibling of ShowdownsPage's inline ShowdownCard — no race
 * count, no prize pool, no Board button, no entry count, and never
 * clickable/routable, since there is no /slate/{id} to send anyone to yet.
 *
 * Reuses the same `sd-card` / `sd-card-badge` CSS classes as ShowdownCard so
 * it sits visually consistent in the same grid, with its own `--planned`
 * tone (see ShowdownsPage.css).
 */

import { formatMeetingDateShort, suggestedShowdownTitle } from '../utils/upcomingMeetingStatus';

export default function PlannedMeetingCard({ meeting }) {
  return (
    <div className="sd-card sd-card--planned sd-card--static">
      <div className="sd-card-image">
        <img src="/track-wp.png" alt="" />
        <div className="sd-card-image-overlay" />

        <span className="sd-card-badge sd-card-badge--status sd-card-badge--planned">
          PLANNED
        </span>

        <div className="sd-card-image-title">
          <div className="sd-card-image-date">{formatMeetingDateShort(meeting.meetingDate)}</div>
          <h3 className="sd-card-name">{suggestedShowdownTitle(meeting)}</h3>
        </div>
      </div>

      <div className="sd-card-body">
        <p className="sd-card-planned-copy">
          {meeting.trackName} · {meeting.state} — this meeting is on the Upcoming Schedule.
          It will appear here as a playable Showdown once the game is created.
        </p>

        <div className="sd-card-actions">
          <button className="sd-btn sd-btn--disabled" disabled type="button">
            Coming Soon
          </button>
        </div>
      </div>
    </div>
  );
}
